module.exports = __webpack_public_path__ + "img/banner3CN.5581b1ce.png";